// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/phone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/mail.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 34px);
  column-gap: 577px;
  row-gap: 64px;
  align-items: center;
  margin: 0 auto 100px;
}

.footer__name {
  margin: 0;
  padding: 0;
  font-size: 24px;
  font-weight: 700;
  font-family: "Montserrat";
  line-height: 34px;
}

.footer__section-number {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.footer__phone-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 24px;
  height: 24px;
  margin-right: 5px;
}

.footer__number {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  font-family: "Montserrat";
  text-decoration: none;
  color: inherit; /* Сохраняет цвет текста как у родителя */
  transition: opacity 0.3s ease;
}

.footer__number:hover {
  opacity: 0.7;
  cursor: pointer;
}

.footer__city {
  font-family: "Montserrat";
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
  padding: 0;
}

.footer__section-email {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.footer__email-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  height: 16px;
  width: 20px;
  margin-right: 5px;
}

.footer__email {
  font-family: "Montserrat";
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
  padding: 0;
  text-decoration: none;
  color: inherit; /* Сохраняет цвет текста как у родителя */
  transition: opacity 0.3s ease;
}

.footer__email:hover {
  opacity: 0.7;
  cursor: pointer;
}

@media screen and (max-width: 1439px) {
  .footer {
    column-gap: 236px;
    row-gap: 34px;
  }

  .footer__name {
    font-size: 18px;
    line-height: 26px;
  }

  .footer__phone-icon {
    width: 16px;
    height: 16px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .footer__number {
    font-size: 16px;
    line-height: 24px;
  }

  .footer__city {
    font-size: 16px;
    line-height: 24px;
  }

  .footer__email-icon {
    width: 16px;
    height: 16px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .footer__email {
    font-size: 16px;
    line-height: 24px;
  }
}

@media screen and (max-width: 1023px) {
  .footer {
    margin-bottom: 50px;
    column-gap: 190px;
    row-gap: 20px;
    max-width: 708px;
  }

  .footer__name {
    font-size: 16px;
    line-height: 24px;
  }

  .footer__number {
    font-size: 14px;
    line-height: 22px;
  }

  .footer__city {
    font-size: 14px;
    line-height: 22px;
  }

  .footer__email {
    font-size: 14px;
    line-height: 22px;
  }
}

@media screen and (max-width: 763px) {
  .footer {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(4, 1fr);
    column-gap: 0px;
    row-gap: 40px;
    margin: 0 auto 80px;
    align-items: center;
    justify-items: center;
  }

  .footer__name {
    font-size: 16px;
    line-height: 24px;
  }

  .footer__number {
    font-size: 16px;
    line-height: 24px;
  }

  .footer__city {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .footer__email {
    font-size: 16px;
    line-height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yDAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc,EAAE,yCAAyC;EACzD,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yDAA8C;EAC9C,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,cAAc,EAAE,yCAAyC;EACzD,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".footer {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  grid-template-rows: repeat(2, 34px);\r\n  column-gap: 577px;\r\n  row-gap: 64px;\r\n  align-items: center;\r\n  margin: 0 auto 100px;\r\n}\r\n\r\n.footer__name {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  font-family: \"Montserrat\";\r\n  line-height: 34px;\r\n}\r\n\r\n.footer__section-number {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.footer__phone-icon {\r\n  background-image: url(\"../../images/phone.svg\");\r\n  width: 24px;\r\n  height: 24px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.footer__number {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  line-height: 28px;\r\n  font-family: \"Montserrat\";\r\n  text-decoration: none;\r\n  color: inherit; /* Сохраняет цвет текста как у родителя */\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.footer__number:hover {\r\n  opacity: 0.7;\r\n  cursor: pointer;\r\n}\r\n\r\n.footer__city {\r\n  font-family: \"Montserrat\";\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  line-height: 28px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.footer__section-email {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.footer__email-icon {\r\n  background-image: url(\"../../images/mail.svg\");\r\n  height: 16px;\r\n  width: 20px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.footer__email {\r\n  font-family: \"Montserrat\";\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  line-height: 28px;\r\n  margin: 0;\r\n  padding: 0;\r\n  text-decoration: none;\r\n  color: inherit; /* Сохраняет цвет текста как у родителя */\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.footer__email:hover {\r\n  opacity: 0.7;\r\n  cursor: pointer;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .footer {\r\n    column-gap: 236px;\r\n    row-gap: 34px;\r\n  }\r\n\r\n  .footer__name {\r\n    font-size: 18px;\r\n    line-height: 26px;\r\n  }\r\n\r\n  .footer__phone-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n  }\r\n\r\n  .footer__number {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n\r\n  .footer__city {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n\r\n  .footer__email-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n  }\r\n\r\n  .footer__email {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .footer {\r\n    margin-bottom: 50px;\r\n    column-gap: 190px;\r\n    row-gap: 20px;\r\n    max-width: 708px;\r\n  }\r\n\r\n  .footer__name {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n\r\n  .footer__number {\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n  }\r\n\r\n  .footer__city {\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n  }\r\n\r\n  .footer__email {\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .footer {\r\n    grid-template-columns: repeat(1, 1fr);\r\n    grid-template-rows: repeat(4, 1fr);\r\n    column-gap: 0px;\r\n    row-gap: 40px;\r\n    margin: 0 auto 80px;\r\n    align-items: center;\r\n    justify-items: center;\r\n  }\r\n\r\n  .footer__name {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n\r\n  .footer__number {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n\r\n  .footer__city {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 24px;\r\n  }\r\n\r\n  .footer__email {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
